import AccountServer from '@/services/AccountServer'

/**
 * 官方术语库是否在当前站点开放。
 *
 * 明确返回空列表时缓存为不可用；网络或鉴权失败时保留入口，交由弹窗展示错误并允许重试。
 * 模块级缓存避免工作台和术语库页在同一页面周期内重复探测。
 *
 * 后端接口现在要求 sourceLang/targetLang；启用库列表与具体语言对无关，
 * 这里固定传 en → zh-Hans 作为探测语言对，是最稳妥的选择。
 */
let cached: boolean | null = null
let inflight: Promise<boolean> | null = null

export function checkPresetTermAvailable(): Promise<boolean> {
  if (cached !== null) return Promise.resolve(cached)
  if (inflight) return inflight

  inflight = AccountServer.getPresetTermList({ sourceLang: 'en', targetLang: 'zh-Hans' })
    .then((res) => {
      if (!res || res.code !== '1') return true
      cached = Array.isArray(res.list) && res.list.length > 0
      return cached
    })
    .catch(() => true)
    .finally(() => {
      inflight = null
    })

  return inflight
}

export function resetPresetTermAvailable() {
  cached = null
  inflight = null
}
